<div style="display: flex; flex-direction: line; justify-content: space-between; align-items: baseline;">
    @if (mode === 'Update') {
    <h2>Edit project</h2>
    } @else {
    <h2>Create new project</h2>
    }
    <div class="n-last-modifications">
        @if (project.lastModifiedOn) {
        Last update: {{project | lastUpdate}}
        }
    </div>
</div>

<form [formGroup]="form" class="form-container">
    <div style="display: flex; flex-direction: column; padding: 10px; gap: 10px;">
        <div style="display: flex; gap: 10px;">
            <mat-form-field appearance="outline" [style.width.px]="300">
                <mat-label>Project short name</mat-label>
                <input matInput type="text" formControlName="shortName">
                @if(form.get('shortName')?.invalid) {
                <mat-error> Project short name is required. </mat-error>
                }
                <mat-hint>
                    @if ((duplicateEntryResource.status() == 'resolved') &&
                    (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                    ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                    <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                        similarityList:'shortNameSimilarity':0.95:'shortName' }}</span>
                    } @else if (duplicateEntryResource.status() == 'error') {
                    <span class="n-duplicate-error">Error checking for similar entries</span>
                    } @else {
                    Use the official acronym
                    }
                </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>EUFIC Role</mat-label>
                <mat-select formControlName="euficRole">
                    @for (option of euficRoleOptions; track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                    }
                </mat-select>
                @if(form.get('euficRole')?.invalid) {
                <mat-error> Project role is required. </mat-error>
                }
            </mat-form-field>
            <ng-container matSuffix>
                @if (duplicateEntryResource.status() == 'loading') {
                <div class="n-spinner-container">
                    <mat-spinner diameter="32"></mat-spinner>
                </div>
                }
            </ng-container>
        </div>
        <mat-form-field appearance="outline" [style.width]="200">
            <mat-label>Project full name</mat-label>
            <input matInput type="text" formControlName="fullName">
            @if(form.get('fullName')?.invalid) {
            <mat-error> Project full name is required. </mat-error>
            }
            <mat-hint>
                @if ((duplicateEntryResource.status() == 'resolved') &&
                (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                    similarityList:'fullNameSimilarity':0.95:'fullName' }}</span>
                }
                @if (duplicateEntryResource.status() == 'error') {
                <span class="n-duplicate-error">Error checking for similar entries</span>
                }
            </mat-hint>
        </mat-form-field>
        <div style="display: flex; gap: 10px;">
            <mat-form-field appearance="outline" [style.width]="200">
                <mat-label>Start date</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                @if(form.get('startDate')?.invalid) {
                <mat-error> Project start date is required. </mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="outline" [style.width]="200">
                <mat-label>End date</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
            <mat-label>Topics of interest</mat-label>
            <app-advanced-chip-select #topicsSelect required placeholder="New topic of interest..."
                formControlName="topics" [allOptions]="allTopicOptions()" />
            <mat-hint>Aim at no more than 5 topics</mat-hint>
            <mat-error>Select at least one topic</mat-error>
        </mat-form-field>

        <div style="display: flex; gap: 0.5rem">
            <mat-form-field appearance="outline" [style.width]="200" style="flex: 1">
                <mat-icon matPrefix>link</mat-icon>
                <mat-label>Website</mat-label>
                <input matInput type="text" formControlName="website">
                <mat-hint>Link to EUFIC website page or project page on knowledge base</mat-hint>
            </mat-form-field>
            <button matMiniFab style="flex-shrink: 0" [disabled]="!form.get('website')?.value" (click)="copyLink()"
                title="Copy to clipboard"><mat-icon>content_copy</mat-icon></button>
            <button matMiniFab style="flex-shrink: 0" [disabled]="!form.get('website')?.value" (click)="openLink()"
                title="Open in a new window"><mat-icon>open_in_new</mat-icon></button>
        </div>
    </div>
</form>

@if (project.id) {
<app-history-panel entityType="project" [entityId]="project.id"></app-history-panel>
}

<div class="n-button-row">
    <button matFab extended class="n-cancel-button" (click)="cancel()"><mat-icon>cancel</mat-icon>Cancel</button>
    <button matFab extended class="n-save-button" [disabled]="form.invalid" (click)="save()"><mat-icon>save</mat-icon>{{
        (mode === 'Create' ?
        'Save'
        : 'Update')}}</button>
    @if (mode === "Update") {
    <button matFab extended class="n-delete-button" [disabled]="!authService.isAdmin" (click)="delete()">
        <mat-icon>delete</mat-icon>
        Delete
    </button>
    }
    <!-- @if (mode === 'Update') {
    <button matFab extended class="n-delete-button" (click)="delete()"><mat-icon>delete</mat-icon>Delete</button>
    } -->
</div>